import type { FC } from 'react';
import { TooltipedIcon } from '@components/TooltipedIcon';
import type { ResourceBlock } from '@domain/schemas/contract.schema';
import { mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';

import { iconClasses } from '../classes';
import { Container } from '../components/Container';
import { getId } from '../utils';

interface EndorsementViewBlockActionsViewProps {
  block: ResourceBlock;
  isHidden: boolean;
  onToggleChangeVisibility: () => void;
}

export const EndorsementViewBlockActionsView: FC<EndorsementViewBlockActionsViewProps> = ({
  block,
  isHidden,
  onToggleChangeVisibility,
}) => {
  return (
    <Container>
      <TooltipedIcon
        size={0.9}
        className={iconClasses()}
        data-testid={getId(isHidden ? 'show-change' : 'hide-change', block.name)}
        path={isHidden ? mdiEyeOutline : mdiEyeOffOutline}
        onClick={onToggleChangeVisibility}
        content={isHidden ? 'Show change' : 'Hide change'}
      />
    </Container>
  );
};
